<!-- FikoEksenComponent - Sadeleştirilmiş Eksen Sistemi -->
<div class="eksen-container" [class.secim-aktif]="secimModu">

  <!-- Seçim Modu Göstergesi -->
  <div class="secim-banner" *ngIf="secimModu">
    <div class="secim-mesaj">
      <i class="crosshairs icon pulse"></i>
      <span>{{ getSecimDurumu() }}</span>
    </div>
    <button class="btn-iptal" (click)="secimBitir()">
      <i class="times icon"></i> İptal
    </button>
  </div>

  <!-- İsim Alanı -->
  <div class="eksen-isim">
    <input type="text" class="input-isim" placeholder="Eksen İsmi"
           [ngModel]="eksen?.name"
           (ngModelChange)="eksen.name=$event; FikoYT.degisti.emit();">
  </div>

  <!-- Merkez Bölümü -->
  <div class="eksen-section merkez-section">
    <div class="section-header">
      <span class="section-icon merkez-icon">⊙</span>
      <span class="section-title">Merkez</span>
      <button class="btn-sec" [class.aktif]="aktifSecimTipi === 'merkez'"
              title="3D'den Seç" (click)="merkezSec()">
        <i class="crosshairs icon"></i>
      </button>
    </div>

    <div class="koordinat-row">
      <div class="koordinat-input">
        <label>X</label>
        <input type="number" step="0.1" [ngModel]="eksen?.merkez?.x"
               (ngModelChange)="merkezDegistir('x', $event)">
      </div>
      <div class="koordinat-input">
        <label>Y</label>
        <input type="number" step="0.1" [ngModel]="eksen?.merkez?.y"
               (ngModelChange)="merkezDegistir('y', $event)">
      </div>
      <div class="koordinat-input">
        <label>Z</label>
        <input type="number" step="0.1" [ngModel]="eksen?.merkez?.z"
               (ngModelChange)="merkezDegistir('z', $event)">
      </div>
    </div>
  </div>

  <!-- Yönler Bölümü -->
  <div class="eksen-section yonler">
    <div class="section-header">
      <span class="section-title">Yönler</span>
    </div>

    <!-- X Yönü -->
    <div class="yon-row x-yon">
      <div class="yon-label">
        <span class="yon-badge x">X</span>
      </div>
      <div class="koordinat-mini">
        <input type="number" step="0.01" [ngModel]="eksen?.xYon?.x"
               (ngModelChange)="yonDegistir('x', 'x', $event)">
        <input type="number" step="0.01" [ngModel]="eksen?.xYon?.y"
               (ngModelChange)="yonDegistir('x', 'y', $event)">
        <input type="number" step="0.01" [ngModel]="eksen?.xYon?.z"
               (ngModelChange)="yonDegistir('x', 'z', $event)">
      </div>
      <button class="btn-sec-mini" [class.aktif]="aktifSecimTipi === 'x-yon'"
              title="Yüzeyden Seç" (click)="yonSec('x')">
        <i class="location arrow icon"></i>
      </button>
    </div>

    <!-- Y Yönü -->
    <div class="yon-row y-yon">
      <div class="yon-label">
        <span class="yon-badge y">Y</span>
      </div>
      <div class="koordinat-mini">
        <input type="number" step="0.01" [ngModel]="eksen?.yYon?.x"
               (ngModelChange)="yonDegistir('y', 'x', $event)">
        <input type="number" step="0.01" [ngModel]="eksen?.yYon?.y"
               (ngModelChange)="yonDegistir('y', 'y', $event)">
        <input type="number" step="0.01" [ngModel]="eksen?.yYon?.z"
               (ngModelChange)="yonDegistir('y', 'z', $event)">
      </div>
      <button class="btn-sec-mini" [class.aktif]="aktifSecimTipi === 'y-yon'"
              title="Yüzeyden Seç" (click)="yonSec('y')">
        <i class="location arrow icon"></i>
      </button>
    </div>

    <!-- Z Yönü -->
    <div class="yon-row z-yon">
      <div class="yon-label">
        <span class="yon-badge z">Z</span>
      </div>
      <div class="koordinat-mini">
        <input type="number" step="0.01" [ngModel]="eksen?.zYon?.x"
               (ngModelChange)="yonDegistir('z', 'x', $event)">
        <input type="number" step="0.01" [ngModel]="eksen?.zYon?.y"
               (ngModelChange)="yonDegistir('z', 'y', $event)">
        <input type="number" step="0.01" [ngModel]="eksen?.zYon?.z"
               (ngModelChange)="yonDegistir('z', 'z', $event)">
      </div>
      <button class="btn-sec-mini" [class.aktif]="aktifSecimTipi === 'z-yon'"
              title="Yüzeyden Seç" (click)="yonSec('z')">
        <i class="location arrow icon"></i>
      </button>
    </div>
  </div>

  <!-- Alt Butonlar -->
  <div class="action-buttons">
    <button class="btn-uygula" (click)="uygula()">
      <i class="check icon"></i> Uygula
    </button>
    <button class="btn-kapat" (click)="kapa()">
      <i class="times icon"></i> Kapat
    </button>
  </div>

</div>
